// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2AUN4","verify":"styles_verify__z6-o9","okay":"styles_okay__VXAf4","close":"styles_close__1NSiy","verify-now":"styles_verify-now__1HEtR"};